export interface IModalTourProps {
  open: boolean;
}
export interface DoneSectionProps {
  updatedUrl: string;
  onClickOk: () => void;
  loading: boolean;
}

export interface OnboardingSectionProps {
  isCheckboxChecked: boolean;
  handleCheckboxChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleDoneClick: () => void;
  handleRemindMeLaterClick: () => void;
  onClickVideoEmbed: () => void;
}

export interface IntroScreenProps {
  generateHcForm?: (data: any) => void;
  showError?: (data: any) => void;
  closeHcForm?: () => void;
  openHcForm?: () => void;
  landingData?: {
    isLoading: boolean;
    helpCenter: {
      isFormOpened: boolean;
    };
  };
}

export interface StepScreenProps {
  updateProfileStep: (data: string) => void;
}

export interface IMerchantDetails {
  merchantName?: string;
  contactPerson?: string;
  addedOn?: string;
}

export interface IProductFruitCampaigns {
  username?: string;
  key?: string;
}



export enum WHITELISTING_STATUS {
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
  IN_REVIEW = 'IN_REVIEW',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  ACTION_PENDING = 'ACTION_PENDING',
}
